import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}
const LandingIcon: FC<Props> = (props) => {
  const { fill, ...prop } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="Landing icon">
      {/* <title>Landing icon</title> */}
      <path
        d="M12.3093 3.74102L16.4183 4.35623C18.6151 4.68494 19.7494 6.43989 19.4207 8.63402L18.5352 14.5545C18.2065 16.7486 16.6087 18.0949 14.411 17.7662L10.3029 17.151C8.10612 16.8223 6.97178 15.0682 7.2996 12.8732L8.18605 6.95272C8.51387 4.7586 10.1189 3.4141 12.3093 3.74102Z"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.38462"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8507 9.09375L16.0001 9.68831M11.3745 12.4128L13.8641 12.7702"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.38462"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32437 6.34619L5.68387 7.21828C3.57147 7.91343 2.7416 9.83362 3.44573 11.946L5.31474 17.6294C6.01079 19.7337 7.81333 20.7899 9.91679 20.0948L13.8739 18.7952C14.5367 18.5859 15.0891 18.2339 15.4914 17.7892"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.38462"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LandingIcon;
